var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "24px",
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CCB1DB88-11E0-49E2-882A-B4BA02A784ED") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.560784 0 0 0 0 0.607843 0 0 0 0 0.662745 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBule---Milestone-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16.0_Switch-Account_02",
    transform: "translate(-1085.000000, -216.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pop-Up-Actions",
    transform: "translate(1074.000000, 53.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Remove-Copy-3",
    transform: "translate(0.000000, 150.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text-Fill",
    transform: "translate(11.105263, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Left",
    transform: "translate(0.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "swap-(1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.62070312,7.47895301 C3.8640625,7.71623523 4.2609375,7.71623523 4.50429687,7.47895301 L5.3125,6.69219514 C5.55625,6.45529318 5.55625,6.06894905 5.3125,5.8320471 L4.50429687,5.04528923 L15.625,5.04528923 C16.6589844,5.04528923 17.5,5.86398893 17.5,6.87053706 C17.5,7.373621 17.9207031,7.78316098 18.4375,7.78316098 L19.0625,7.78316098 C19.5792969,7.78316098 20,7.373621 20,6.87053706 C20,4.52205151 18.0375,2.61162544 15.625,2.61162544 L4.50429687,2.61162544 L5.3125,1.82486758 C5.55625,1.58796562 5.55625,1.20162149 5.3125,0.964719533 L4.50429687,0.177961664 C4.2609375,-0.0593205547 3.8640625,-0.0593205547 3.62070312,0.177961664 L0.09140625,3.61323019 C-0.03046875,3.73225156 -0.03046875,3.92466311 0.09140625,4.04368448 L3.62070312,7.47895301 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3792969,10.5210327 C16.1359375,10.2837505 15.7394531,10.2837505 15.4957031,10.5210327 L14.6875,11.3077906 C14.4432813,11.5455291 14.4428906,11.9298199 14.6875,12.1679386 L15.4957031,12.9546965 L4.375,12.9546965 C3.34101562,12.9546965 2.5,12.1359968 2.5,11.1294487 C2.5,10.6263647 2.07929688,10.2168248 1.5625,10.2168248 L0.9375,10.2168248 C0.420703125,10.2168248 0,10.6263647 0,11.1294487 C0,13.4779342 1.9625,15.3883603 4.375,15.3883603 L15.4957031,15.3883603 L14.6875,16.1751182 C14.4432813,16.4128567 14.4428906,16.7971474 14.6875,17.0352662 L15.4957031,17.8220241 C15.7394922,18.0593443 16.1355469,18.0593063 16.3792969,17.8220241 L19.9085937,14.3867555 C20.0304687,14.2677342 20.0304687,14.0753226 19.9085937,13.9563013 L16.3792969,10.5210327 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.f3d52988b1b036c87d4b3e63701022eb.svg";
export { ForwardRef as ReactComponent };